import React, { Suspense, useContext } from 'react'
import { Route as RouterRoute, Redirect } from 'react-router-dom'
import { AuthContext } from '../context/Auth/AuthContext'
import BackdropLoading from '../components/BackdropLoading'
import usePermission from '../hooks/usePermission'

const Route = ({ component: Component, isPrivate = false, permission, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext)
  const { hasPermission, firstPermissionRoute } = usePermission()

  return (
    <RouterRoute
      {...rest}
      render={props => {
        // 1) espere auth/permissions antes de decidir
        const permsNeeded = isPrivate && !!permission
        const permsReady = !permsNeeded || Array.isArray(user?.permissions)

        if (loading || (permsNeeded && !permsReady)) {
          return <BackdropLoading />
        }

        // 2) regras de auth
        if (!isAuth && isPrivate) {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        if (isAuth && !isPrivate) {
          return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        }

        // 3) checagem de permissão (só depois de permsReady)
        if (permsNeeded && !hasPermission(permission)) {
          return <Redirect to={{ pathname: firstPermissionRoute(), state: { from: props.location } }} />
        }

        // 4) render normal
        return (
          <Suspense fallback={<BackdropLoading />}>
            <Component {...props} />
          </Suspense>
        )
      }}
    />
  )
}

export default Route
